import { useEffect, useState } from 'react';
import { Link } from '@tanstack/react-router';
import { requestPasswordReset, resetPassword } from './api/session';
import { Button, ErrorState, Field } from './ui';
import { EMAIL_ENABLED } from './features';

export function PasswordRecoveryScreen() {
  const resetting = window.location.pathname === '/reset-password';
  const [actionToken] = useState(
    () => new URLSearchParams(window.location.hash.slice(1)).get('token') || '',
  );
  const [pending, setPending] = useState(false);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    if (actionToken) history.replaceState(null, '', window.location.pathname);
  }, [actionToken]);
  return (
    <main className="auth-page">
      <div className="auth-brand">
        <img src="/assets/snaphire-icon.png" alt="" />
        <span>SnapHire</span>
      </div>
      <section className="auth-card">
        <h1>{resetting ? 'Новый пароль' : 'Восстановление доступа'}</h1>
        {!resetting && !EMAIL_ENABLED ? (
          <>
            <p>Получите ссылку для смены пароля у администратора.</p>
            <Link className="pill primary full" to="/">
              Вернуться к входу
            </Link>
          </>
        ) : complete ? (
          <>
            <p role="status">
              {resetting
                ? 'Пароль изменён. Войдите с новым паролем.'
                : 'Если учётная запись существует, письмо со ссылкой для восстановления придёт на указанную почту.'}
            </p>
            <Link className="pill primary full" to="/">
              Вернуться к входу
            </Link>
          </>
        ) : (
          <form
            onSubmit={async (event) => {
              event.preventDefault();
              setPending(true);
              setError(null);
              const data = new FormData(event.currentTarget);
              try {
                if (resetting) {
                  if (!actionToken) throw new Error('Откройте ссылку восстановления из письма');
                  if (data.get('password') !== data.get('confirmation'))
                    throw new Error('Пароли не совпадают');
                  await resetPassword(actionToken, String(data.get('password')));
                } else await requestPasswordReset(String(data.get('email')));
                setComplete(true);
              } catch (cause) {
                setError(cause as Error);
              } finally {
                setPending(false);
              }
            }}
          >
            {resetting ? (
              <>
                <p className="muted">Задайте новый пароль длиной не менее 12 символов.</p>
                <Field
                  label="Новый пароль"
                  name="password"
                  type="password"
                  autoComplete="new-password"
                  minLength={12}
                  maxLength={128}
                  required
                />
                <Field
                  label="Повторите пароль"
                  name="confirmation"
                  type="password"
                  autoComplete="new-password"
                  minLength={12}
                  maxLength={128}
                  required
                />
              </>
            ) : (
              <>
                <p className="muted">Укажите рабочую почту, связанную с вашей учётной записью.</p>
                <Field
                  label="Рабочая почта"
                  name="email"
                  type="email"
                  autoComplete="username"
                  required
                />
              </>
            )}
            {error && <ErrorState error={error} />}
            <Button type="submit" className="primary full" disabled={pending}>
              {pending ? 'Подождите…' : resetting ? 'Сохранить пароль' : 'Отправить ссылку'}
            </Button>
            <Link className="pill full" to="/">
              Вернуться к входу
            </Link>
          </form>
        )}
      </section>
    </main>
  );
}
